import { render, staticRenderFns } from "./MassMessageStatView.vue?vue&type=template&id=a3131844&scoped=true&"
import script from "./MassMessageStatView.vue?vue&type=script&lang=ts&"
export * from "./MassMessageStatView.vue?vue&type=script&lang=ts&"
import style0 from "./MassMessageStatView.vue?vue&type=style&index=0&id=a3131844&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3131844",
  null
  
)

export default component.exports